import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICompanyDataDataTableRowFormMeta {
  typeCard: FormInputMeta,
  cardProgram: FormInputMeta,
  prepaidProgram: FormInputMeta,
  
  schema: any,
}

const CompanyDataDataTableRowFormMeta = {} as ICompanyDataDataTableRowFormMeta;



CompanyDataDataTableRowFormMeta.typeCard = {
  name: "typeCard",
  label: "Type Carte",
  type: "select",
  options:  [
    {
      label: 'Type Carte A',
      value: 'a'
    },
    {
      label: 'Type Carte B',
      value: 'b',
    },
    {
      label: 'Type Carte C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};

CompanyDataDataTableRowFormMeta.cardProgram = {
  name: "cardProgram",
  label: "Prog. carte",
  type: "select",
  options:  [
    {
      label: 'Prog. carte A',
      value: 'a'
    },
    {
      label: 'Prog. carte B',
      value: 'b',
    },
    {
      label: 'Prog. carte C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};

CompanyDataDataTableRowFormMeta.prepaidProgram = {
  name: "prepaidProgram",
  label: "Prog.prépayé",
  type: "select",
  options:  [
    {
      label: 'Prog. prépayé A',
      value: 'a'
    },
    {
      label: 'Prog. prépayé B',
      value: 'b',
    },
    {
      label: 'Prog. prépayé C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};

CompanyDataDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(CompanyDataDataTableRowFormMeta));

export default CompanyDataDataTableRowFormMeta;